import React from 'react'

export default class Tabs extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        let { headerData, headerIndex, onClick } = this.props
        return <div className="tabBox">
            {
                headerData.map((v, i) => {
                    let flag = i == headerIndex
                    return <div
                        key={i}
                        onClick={() => {
                            if (flag) return
                            onClick(i)
                        }}
                        className={`headerBoxList ${flag ? `headerBoxListActive` : ''}`}
                    >{v.text}</div>
                })
            }
        </div>
    }
}